import { useEffect } from "react";
import { getAdConfigs } from "@/lib/adSettings";

// This component ensures the Google AdSense script is loaded exactly once
// if any enabled Google Ad placement exists.

export const AdSenseLoader = () => {
    useEffect(() => {
        const configs = getAdConfigs();
        const googleAdsEnabled = configs.some(c => c.enabled && c.type === 'google_ads');
        const clientId = configs.find(c => c.googleAdClient)?.googleAdClient;

        // Validate client ID format
        const isValidClientId = clientId && clientId.startsWith('ca-pub-') && clientId.length > 10;

        // Check if we're in a production-like environment (Vercel, Netlify, etc.)
        const isProduction = process.env.NODE_ENV === 'production' ||
            window.location.hostname !== 'localhost' &&
            window.location.hostname !== '127.0.0.1';

        if (googleAdsEnabled && isValidClientId && !document.getElementById("google-ads-script")) {
            const script = document.createElement("script");
            script.id = "google-ads-script";
            script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${clientId}`;
            script.async = true;
            script.crossOrigin = "anonymous";

            script.onerror = (error) => {
                if (isProduction) {
                    console.error("AdSense script failed to load:", error);
                } else {
                    console.warn("AdSense script failed to load - this is normal in development:", error);
                }
            };

            document.head.appendChild(script);
        }
    }, []);

    return null;
};
